'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addHours;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/addHours.js
// module id = 240
// module chunks = 0